import Mock from './mock';
import {getEnv} from 'ecx.saigon.ui.common';
import {getQuote as query} from '@/api/graphql/quote';
import apolloClient from '../../utils/apollo-client';
import {GQL_ERROR_CODES} from '../../utils/constants';

export default async function getQuote(quoteId) {
  const env = await getEnv();

  if (env.VUE_APP_USE_MOCK) {
    return Mock.data.getQuote;
  }
  const response = await apolloClient().then((client) =>
    client
      .query({
        query,
        variables: {quoteId},
      })
      .catch((error) => {
        if (error.networkError) {
          const {code} = error.networkError?.extensions || {};

          if (code === GQL_ERROR_CODES.notFound || code === GQL_ERROR_CODES.forbidden) {
            throw new Error(GQL_ERROR_CODES.notFound);
          }
        }
        throw new Error(error);
      }),
  );

  return response.data.getQuote;
}
